/** One committed presentation boundary, including gates replacing deep links. Lifecycle never emits views. */
import { useLayoutEffect } from 'react'
import { captureShopifyDiagnosticScope, type ShopifyAppBridge } from '../../shopifyApiFetch'
import { getShopifyJourney } from '../../shopifyJourney'
import { shopifyUiTracker } from '../../shopifyUiTracking'
import type { ShopifyTrackingPageId } from '../../shopifyTrackingCatalog'

export function useShopifyUiView(input: {
  shopify: ShopifyAppBridge
  shop: string | null
  pageId: ShopifyTrackingPageId
  screenId: string
  resourceKey: string
  unconnected: boolean
}) {
  const { shopify, shop, pageId, screenId, resourceKey, unconnected } = input
  const identity = captureShopifyDiagnosticScope(shopify).sessionIdentity
  useLayoutEffect(() => {
    if (!shop) return
    const { sessionIdentity } = captureShopifyDiagnosticScope(shopify)
    if (sessionIdentity?.shopDomain !== shop) {
      console.error('UI_EVENT_VERIFIED_SCOPE_UNAVAILABLE')
      return
    }
    const journeyId = getShopifyJourney(shop, unconnected)
    const scopeKey = JSON.stringify([
      sessionIdentity.shopDomain,
      sessionIdentity.userId,
      sessionIdentity.sessionId,
      resourceKey,
    ])
    shopifyUiTracker(shopify).enter(pageId, screenId, scopeKey, journeyId)
  }, [
    shopify,
    shop,
    pageId,
    screenId,
    resourceKey,
    unconnected,
    identity?.shopDomain,
    identity?.userId,
    identity?.sessionId,
  ])
}
